export default __webpack_public_path__ + "static/garden_design30-5fcc173a6e90881b2e75faee251a3195.webp";